export const FETCH_COMPANY_PROFILE_TYPES = "FETCH_COMPANY_PROFILE_TYPES";
export const FETCH_COMPANY_PROFILE_TYPE = "FETCH_COMPANY_PROFILE_TYPE";
export const CREATE_COMPANY_PROFILE_TYPE = "CREATE_COMPANY_PROFILE_TYPE";
export const UPDATE_COMPANY_PROFILE_TYPE = "UPDATE_COMPANY_PROFILE_TYPE";
export const DELETE_COMPANY_PROFILE_TYPE = "DELETE_COMPANY_PROFILE_TYPE";

export function fetchCompanyProfileTypes(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_COMPANY_PROFILE_TYPES,
    auth: true,
    payload: {
      url: "superuser/company-profile-types",
      method: "GET",
      params
    }
  };
}

export function fetchCompanyProfileType(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_COMPANY_PROFILE_TYPE,
    auth: true,
    payload: {
      url: `superuser/company-profile-types/${id}`,
      method: "GET",
      params
    }
  };
}

export function createCompanyProfileType(data = {}) {
  return {
    type: CREATE_COMPANY_PROFILE_TYPE,
    auth: true,
    payload: {
      url: "superuser/company-profile-types",
      method: "POST",
      data
    }
  };
}

export function updateCompanyProfileType(id, data = {}) {
  return {
    type: UPDATE_COMPANY_PROFILE_TYPE,
    auth: true,
    payload: {
      url: `superuser/company-profile-types/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteCompanyProfileType(id, data = {}) {
  return {
    type: DELETE_COMPANY_PROFILE_TYPE,
    auth: true,
    payload: {
      url: `superuser/company-profile-types/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/companyProfileType.js